var lib_core             = require("lib-core");

var ui_extensions = require("ui-extensions");

var Editor3DModel        = require("./editor3dModel.js");
var Editor3DView         = require("./editor3dView.js");
var Editor3DStateMachine = require("./editor3dStateMachine.js");
var AbstractView         = require("editor-2d").AbstractView;

var Editor3DController = function(archLayers, dependencies, options) {

    ui_extensions.AbstractEditorController.call(this, archLayers, dependencies, options);

    // Define possible GUI events
    lib_core.GuiEvents.addEvents({
        EDITOR_MOUSE_DOWN:            {id: 'abs_1', name: "EDITOR_MOUSE_DOWN"               },
        EDITOR_MOUSE_MOVE:            {id: 'abs_2', name: "EDITOR_MOUSE_MOVE",             isHoverAction: true},
        EDITOR_MOUSE_UP:              {id: 'abs_3', name: "EDITOR_MOUSE_UP"                },
        EDITOR_TRANSFORM_START:       {id: 'abs_4', name: "EDITOR_TRANSFORM_START"         },
        EDITOR_TRANSFORM:             {id: 'abs_5', name: "EDITOR_TRANSFORM"               },
        EDITOR_TRANSFORM_END:         {id: 'abs_6', name: "EDITOR_TRANSFORM_END"           },
        EDITOR_TOUCH_PAN_START:       {id: 'abs_7', name: "EDITOR_TOUCH_PAN_START"         },
        EDITOR_TOUCH_PAN:             {id: 'abs_8', name: "EDITOR_TOUCH_PAN"               },
        EDITOR_TOUCH_PAN_END:         {id: 'abs_9', name: "EDITOR_TOUCH_PAN_END"           },
        EDITOR_TIMER:                 {id: 'abs_10', name: "EDITOR_TIMER"                  },
        CANVAS_MOUSE_DOWN:            {id: 'abs_41', name: "CANVAS_MOUSE_DOWN"          },
        CANVAS_MOUSE_UP:              {id: 'abs_42', name: "CANVAS_MOUSE_UP"            },
        CANVAS_MOUSE_MOVE:            {id: 'abs_43', name: "CANVAS_MOUSE_MOVE"          },
        CANVAS_MOUSE_WHEEL:           {id: 'abs_0', name: "CANVAS_MOUSE_WHEEL",            isViewAction: true},
        WORLD_MOUSE_DOWN:             {id:  'abs_44', name: "WORLD_MOUSE_DOWN"           },
        GUI_KEY_PRESSED:              {id: 'abs_11', name: "GUI_KEY_PRESSED"             },
        GUI_KEY_RELEASED:             {id: 'abs_31', name: "GUI_KEY_RELEASED"            },
        GUI_TIMER:                    {id: 'abs_32', name: "GUI_TIMER"                   },
        ELEMENT_MOUSE_DOWN:           {id: 'abs_12', name: "ELEMENT_MOUSE_DOWN"          },
        ELEMENT_MOUSE_DOWN_VIEWMODUS: {id: 'abs_13', name: "ELEMENT_MOUSE_DOWN_VIEWMODUS"},
        TERMINAL_MOUSE_DOWN:          {id: 'abs_14', name: "TERMINAL_MOUSE_DOWN"         },

        TERMINAL_MOUSE_OVER:          {id: 'abs_16', name: "TERMINAL_MOUSE_OVER",        isHoverAction: true},
        TERMINAL_MOUSE_OUT:           {id: 'abs_17', name: "TERMINAL_MOUSE_OUT",         isHoverAction: true},
        INSPECTOR_FOCUS:              {id: 'abs_18', name: "INSPECTOR_FOCUS"             },
        CHANGE_PROPERTY:              {id: 'abs_19', name: "CHANGE_PROPERTY"             },
        RECORDER_VIEW_BUTTON:         {id: 'abs_28', name: "RECORDER_VIEW_BUTTON",       isGuiButton: true },
        // EDITOR_CANVAS_RESIZE:      {id: 'abs_29', name: "EDITOR_CANVAS_RESIZE"        },
        HANDLE_MOUSE_DOWN:            {id: 'abs_33', name: "HANDLE_MOUSE_DOWN"           },
        HANDLE_MOUSE_UP:              {id: 'abs_34', name: "HANDLE_MOUSE_UP"             },
        HANDLE_MOUSE_OVER:            {id: 'abs_35', name: "HANDLE_MOUSE_OVER"           },
        HANDLE_MOUSE_OUT:             {id: 'abs_36', name: "HANDLE_MOUSE_OUT"            },

    });

    this.dataModelViewMap = new lib_core.Collections.HashMap(lib_core.hash.arrayHash);
};

lib_core.inherit(Editor3DController, ui_extensions.AbstractEditorController);
Editor3DController.inject = {
    masterController : ui_extensions.MasterController,
    tabController : ui_extensions.TabController
};

module.exports = Editor3DController;

Editor3DController.prototype.afterLoad = function (config, container) {
    var self = this;

    lib_core.Controller.prototype.afterLoad.call(this, config, container);

    if (this.parent().registerEditor)
        this.parent().registerEditor(this);
};

Editor3DController.prototype.afterBuild = function () {
    var self = this;

    this.connectDataModelViews();

    ui_extensions.AbstractEditorController.prototype.afterBuild.call(this);

    this.getView().render();
};


Editor3DController.prototype.registerDataModelView = function(dataClass, dataCollection, interactionModelClass, viewClass, extraViewArgs, IMOptions) {
    console.assert(dataClass);
    console.assert(dataCollection);
    console.assert(interactionModelClass);
    this.dataModelViewMap.put([dataClass, dataCollection], [interactionModelClass, viewClass, extraViewArgs, IMOptions]);
};


Editor3DController.prototype.connectDataModelViews = function() {
    var self = this;
    var interactionModelDataMap = this.getModel().interactionModelDataMap;
    self.dataModelViewMap.forEach(function(key, value) {
        var dataClass = key[0];
        var dataContainer = key[1];
        var interactionModel = value[0];
        var viewClass = value[1];
        var extraViewArgs = value[2];
        var IMOptions = value[3];

        function makeIMView(element){
            // make interactionmodel
            var im = new interactionModel(element, self.getModel(), IMOptions );
            console.assert(!interactionModelDataMap.contains(element), "Not allowed to build 2 different interactionModels in same editor for 1 data-element");
            interactionModelDataMap.put(element, im);

            // make view
            if (viewClass){
                var view;
                if (!extraViewArgs) view = new viewClass(self.getView(), im, self.getView()/*.rootGroup*/);
                else view = lib_core.create(viewClass, [self.getView(), im, self.getView()/*.rootGroup*/].concat(extraViewArgs));

                im.onDie({}, function(o){   // if interactionModel dies, remove view as well
                   // view.removeSvg();
                   view.erase();
                },101);
            }
        }

        var dataContainers = (dataContainer.constructor == Array) ? dataContainer : [dataContainer];
        dataContainers.forEach(function(dataContainer) {
            if (dataContainer.getType() === "value") {
                var element = dataContainer();
                if(element && element.constructor == dataClass) makeIMView(element);
                dataContainer.onChange({}, function(element, old) {
                    if(old == element) return;
                    if(old && old.constructor == dataClass) interactionModelDataMap.remove(old);
                    if(element && element.constructor == dataClass) makeIMView(element);
                });
            } else {// or a single object
                dataContainer.forEach(function (key, element) {
                    if(element && element.constructor == dataClass) makeIMView(element);
                });
                dataContainer.onAdd({}, function (key, element) {
                    if(element && element.constructor == dataClass) makeIMView(element);
                }, 2);   // Give it priority 2 to make sure the interactionmodel is added first
                dataContainer.onRemove({}, function (key, old) { //
                    if(old && old.constructor == dataClass) interactionModelDataMap.remove(old);
                });
            }
        });
    });
};


Editor3DController.prototype.doLazyMigrations = function() {
    // Track the following changes as this might change the data model
    this.root.recShareOnly();

    // Only save but don't create an undo level
    this.root.stopRecShareOnly();
};

Editor3DController.prototype.createStateMachine = function () {
    return new Editor3DStateMachine(this.root, this.getModel());
};

Editor3DController.prototype.createModel = function () {

    var editor3DModel = new Editor3DModel(this.configuration);

    editor3DModel.type(this.name());

    return editor3DModel;
};

Editor3DController.prototype.registerDataModelView = function(dataClass, dataCollection, interactionModelClass, viewClass, extraViewArgs, IMOptions) {
    console.assert(dataClass);
    console.assert(dataCollection);
    console.assert(interactionModelClass);
    this.dataModelViewMap.put([dataClass, dataCollection], [interactionModelClass, viewClass, extraViewArgs, IMOptions]);
};

Editor3DController.prototype.createView = function () {

    // #TODO: replace this.parent with abstract interface for extensions that can hold an editor
    // Get parent UI template and pass an identifier in case the parent can hold multiple editors
    var parentTemplate = null;
    var heavyHandler = null;

    parentTemplate = this.parent().getView().getTemplate(this.name());
    var tabController = this.tabController;
    heavyHandler = tabController.heavyHandler;

    var view = new Editor3DView(parentTemplate, this.configuration.mode, this.root, this.getStatemachine(), this.getModel(), this.layers, this.layerOptions, heavyHandler, this.configuration);

    if (!this.configuration.disableKeys){
        AbstractView.addKeyBindings.apply(view);
    }

    return view;
};

Editor3DController.prototype.getDataCollection = function () {
    var data = this.config["data"];
    var dataCollection = null;
    if(data) dataCollection = data.ownerMember;
    if(!dataCollection)
        if(this.parent() && this.parent().getCollection)
            dataCollection = this.parent().getCollection();
    return dataCollection;
};

Editor3DController.prototype.getViewCollection = function () {
    if(this.parent().getViewCollection)
        return this.parent().getViewCollection();
    else
        return null;
};


